import { render, staticRenderFns } from "./home-footer.vue?vue&type=template&id=6ce70115&scoped=true&"
import script from "./home-footer.vue?vue&type=script&lang=js&"
export * from "./home-footer.vue?vue&type=script&lang=js&"
import style0 from "./home-footer.vue?vue&type=style&index=0&id=6ce70115&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce70115",
  null
  
)

export default component.exports